<template>
  <div>
    <v-tooltip top>
      <template #activator="{ on, attrs }">
        <v-icon
          v-if="
            params &&
            params.context &&
            params.context.parentComponent &&
            params.context.parentComponent.permissions &&
            params.context.parentComponent.permissions.change &&
            params.data.status == 'Pending'
          "
          color="primary"
          v-on="on"
          v-bind="attrs"
          @click="editItem"
          class="ml-1 mr-2"
        >
          mdi-pencil
        </v-icon>
        <v-icon
          v-if="
            params &&
            params.context &&
            params.context.parentComponent &&
            params.context.parentComponent.permissions &&
            params.context.parentComponent.permissions.change &&
            params.data.status == 'Sent' &&
            params.data.is_quotation_created_by_admin
          "
          color="primary"
          v-on="on"
          v-bind="attrs"
          @click="editadminQuotationItem"
          class="ml-1 mr-2"
        >
          mdi-pencil
        </v-icon>
      </template>
      <span>Edit</span>
    </v-tooltip>

    <v-tooltip top>
      <template #activator="{ on, attrs }">
        <v-icon
          color="primary"
          v-on="on"
          v-bind="attrs"
          @click="viewDetails"
          class="mr-1 ml-2"
        >
          mdi-eye
        </v-icon>
      </template>
      <span>View</span>
    </v-tooltip>
  </div>
</template>

<script>
export default {
  methods: {
    editItem() {
      this.params.context.parentComponent.editQuotation(this.params.data.id);
    },
    editadminQuotationItem() {
      this.params.context.parentComponent.editadminQuotation(this.params.data.id);
    },
    viewDetails() {
      this.params.context.parentComponent.viewDetails(this.params.data.id);
    },
  },
};
</script>
